var render, staticRenderFns
import script from "./previewItem.vue?vue&type=script&lang=js&"
export * from "./previewItem.vue?vue&type=script&lang=js&"
import style0 from "./previewItem.vue?vue&type=style&index=0&id=01cc7848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc7848",
  null
  
)

component.options.__file = "previewItem.vue"
export default component.exports